<template>
<div class="content-body tenant-settings">
    <div class="">
        <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" size="small">
            <el-form-item label="ASN编码:">
                <el-input size="small" v-model="dataForm.asncode" placeholder="ASN编码" clearable @blur="getDataList"></el-input>
            </el-form-item>
            <!-- <el-form-item label="项目名称(暂时对应供应商编码):">
                <el-input size="small" v-model="dataForm.supplierCode" placeholder="项目名称" clearable @blur="getDataList"></el-input>
            </el-form-item> -->
            <el-form-item label="供应商名称:">
                <el-input size="small" v-model="dataForm.supplierName" placeholder="供应商名称" clearable @blur="getDataList"></el-input>
            </el-form-item>
            <!-- <el-form-item label="供货时间:"> -->
            <!-- 暂不可用 -->
            <!-- <el-input size="mini" v-model="dataForm.deliveryDate" placeholder="供货时间" clearable @blur="getDataList"></el-input> -->
            <!-- <el-date-picker v-model="dataForm.deliveryDate" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间">
            </el-date-picker>
            </el-form-item> -->
            <!-- <el-form-item label="收货时间:(暂不可用)">
                <el-input size="small" v-model="dataForm.recieveyDate" placeholder="收货时间" clearable @blur="getDataList"></el-input>
            </el-form-item> -->
            <el-form-item label="ASN状态:">
                <!-- <el-input size="small" v-model="dataForm.asnStatus" placeholder="ASN状态" clearable @blur="getDataList"></el-input> -->
                <el-select size="small" v-model="dataForm.asnStatus" placeholder="请选择ASN状态" clearable @change="getDataList">
                    <el-option v-for="item in ASN_STATUS" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item class="fr">
                <el-button size="small" @click="getDataList()" icon="el-icon-search">
                    查询
                </el-button>
                <el-button size="small" v-if="isAuth('sourcing:delivery:newbutton')" type="primary" @click="addOrUpdateHandle()" icon="el-icon-plus">
                    新建ASN
                </el-button>
            </el-form-item>
        </el-form>
        <div v-loading="dataListLoading">
            <el-table :data="dataList" row-key="id" size="mini" border style="width: 100%;" :default-expand-all="false" :header-cell-style="{background:'#f5f5f5'}" :height="tableHeight">
                <el-table-column type="index" width="50" label="序号">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
                    </template>
                </el-table-column>
                <el-table-column prop="asncode" header-align="center" align="left" label="ASN编码" width="150">
                </el-table-column>
                <el-table-column prop="supplierCode" header-align="center" align="left" label="供应商代码" width="150">
                </el-table-column>
                <el-table-column prop="supplierName" header-align="center" align="left" label="供应商名称">
                </el-table-column>
                <el-table-column prop="deliveryAddress" header-align="center" align="left" label="收货地址" width="300">
                </el-table-column>
                <el-table-column prop="deliveryDate" header-align="center" align="right" label="供货日期" :formatter="dateFormat" width="150">
                </el-table-column>
                <el-table-column prop="recieveyDate" header-align="center" align="right" label="到货日期" :formatter="dateFormat" width="150">
                </el-table-column>
                <el-table-column prop="asnStatus" header-align="center" align="center" label="ASN状态" width="100">
                    <template slot-scope="scope">
                        <span>{{asnStatusFormat(scope.row.asnStatus)}}</span>
                    </template>
                </el-table-column>
                <el-table-column v-if="isAuth('sourcing:delivery:newbutton')" header-align="center" align="left" width="240" label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="viewHandle(scope.row)" icon="el-icon-view">
                            查看
                        </el-button>
                        <el-button v-if="isAuth('sourcing:supplier:button')" type="text" size="small" @click="addOrUpdateHandle(scope.row)" icon="el-icon-edit">
                            修改
                        </el-button>
                        <el-button v-if="isAuth('sourcing:sgwl:button')" type="text" size="small" @click="addOrUpdateHandle(scope.row)" icon="el-icon-edit">
                            审批
                        </el-button>
                        <el-button type="text" size="small" @click="deleteHandle(scope.row.id)" icon="el-icon-delete" class="text-danger">
                            删除
                        </el-button>
                        <el-button :disabled="scope.row.asnStatus !== '2'" type="text" size="small" @click="exportData(scope.row)" icon="el-icon-edit">
                            导出
                        </el-button>
                    </template>
                </el-table-column>
                <el-table-column v-if="isAuth('sourcing:delivery:newbutton')" header-align="center" align="center" width="100" label="审批后删除">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" :disabled="scope.row.asnStatus !== '2'" @click="changeAsnStatus(scope.row)" icon="el-icon-delete" class="button-danger">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper">
            </el-pagination>
        </div>
        <!-- 弹窗, 新增 / 修改 -->
        <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
</div>
</template>

<script>
import {
    getLabelByValue,
    ASN_STATUS,
    PRODUCTION_ORDER_STATUS,
} from "@/utils/const";
import {
    fetchDeliveryList,
    deleteDelivery,
    exportDelivery,
    editDelivery,
} from '@/controller/delivery'
import AddOrUpdate from './delivered-add-or-update'
import moment from 'moment'
// require('@/mock/mockDelivery');
export default {
    data() {
        return {
            documentClientHeight: document.documentElement['clientHeight'] - 250,
            dataForm: {
                asncode: '',
                supplierName: '',
                deliveryDate: '',
                asnStatus: '',
                // ...this.dataForm,
            },
            ASN_STATUS: ASN_STATUS,
            getLabelByValue: getLabelByValue,
            PRODUCTION_ORDER_STATUS: PRODUCTION_ORDER_STATUS,
            dataList: [],
            tenantList: [],
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
            dataListLoading: false,
            dataListSelections: [],
            addOrUpdateVisible: false
        }
    },
    components: {
        AddOrUpdate
    },
    activated() {
        this.getDataList()
    },
    computed: {
        tableHeight: {
            get() {
                return this.$store.state.common.documentClientHeight - 220
            }
        }
    },
    methods: {
        // 订单状态
        orderStatusFormat: function (value) {
            if (!value) {
                return "";
            }
            return getProductionOrderStatusByValue(PRODUCTION_ORDER_STATUS, value);
        },
        // 订单关闭按钮
        changeAsnStatus(row) {
            console.log(row.status)
            this.$confirm(`确定关闭交货单?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                row.asnStatus = '4',
                    editDelivery(row)
                    .then((data) => {
                        if (data && data.code === "00") {
                            this.$message({
                                message: '交货单关闭成功',
                                type: 'success',
                                duration: 1500,
                                onClose: () => {
                                    this.getDataList()
                                }
                            })
                        } else {
                            this.$message.error(data.msg);
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            })
        },
        dateFormat: function (row, column) {
            var date = row[column.property]
            if (!date) {
                return ''
            }
            return moment(date).format("YYYY-MM-DD")
        },
        asnStatusFormat: function (value) {
            if (!value) {
                return "";
            }
            return getLabelByValue(ASN_STATUS, value);
        },
        // 获取数据列表
        getDataList() {
            this.dataListLoading = true
            fetchDeliveryList({
                pageNo: this.pageIndex,
                pageSize: this.pageSize,
                asncode: this.dataForm.asncode,
                supplierCode: this.dataForm.supplierCode,
                'supplierName': this.dataForm.supplierName,
                'deliveryDate': this.dataForm.deliveryDate,
                recieveyDate: this.dataForm.recieveyDate,
                asnStatus: this.dataForm.asnStatus,
            }).then(data => {
                console.log(data, 'data')
                if (data && data.code === '00') {
                    this.dataList = data.body.records;
                    this.totalPage = data.body.total
                } else {
                    this.dataList = []
                    this.totalPage = 0
                }
            }).catch((e) => {
                console.log(e)
            }).finally(() => {
                this.dataListLoading = false
            })
        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val
            this.pageIndex = 1
            this.getDataList()
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val
            this.getDataList()
        },
        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val
        },
        // 新增 / 修改
        addOrUpdateHandle(row) {
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(row, row ? row.id : null, 'edit')
            })
        },
        viewHandle(row) {
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(row, row ? row.id : null, 'view')
            })
        },
        // 删除
        deleteHandle(id) {
            this.$confirm(`确定进行删除操作?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteDelivery({}, id).then(data => {
                    if (data && data.code === '00') {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                            onClose: () => {
                                this.getDataList()
                            }
                        })
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            })
        },

        exportData(rec) {
            exportDelivery(rec).then(data => {
                if (data && data.code === '00') {

                    console.log(data)
                    this.readAsBinaryString(data.body)
                    this.$message({
                        message: '操作成功',
                        type: 'success',
                        duration: 1500,
                        onClose: () => {
                            // this.getDataList()
                        }
                    })
                } else {
                    this.$message.error(data.msg)
                }
            })
        },
        readAsBinaryString(data) {
            // const name = decodeURI(res.headers['content-disposition'].split('filename=')[1]);
            // const blob = new Blob(content, {type: 'application/vnd.ms-excel;charset=utf-8'}); // 创建一个类文件对象：Blob对象表示一个不可变的、原始数据的类文件对象
            const blob = this.str2Blob(data.content, 'application/vnd.ms-excel;charset=utf-8'); // 创建一个类文件对象：Blob对象表示一个不可变的、原始数据的类文件对象
            const url = window.URL.createObjectURL(blob); // URL.createObjectURL(object)表示生成一个File对象或Blob对象
            let dom = document.createElement('a'); // 设置一个隐藏的a标签，href为输出流，设置download
            dom.style.display = 'none';
            dom.href = url;
            dom.setAttribute('download', decodeURI(data.fileName)); // 指示浏览器下载url,而不是导航到它；因此将提示用户将其保存为本地文件
            document.body.appendChild(dom);
            dom.click();
        },
        str2Blob(str, mime) {
            var arr = str.split(',')
            var bstr = atob(arr[0]),
                n = bstr.length,
                u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new Blob([u8arr], {
                type: mime
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.button-danger {
    color: #F56C6C
}

.text-danger {
    color: #F56C6C
}

.text-success {
    color: #67C23A
}

.text-waming {
    color: #E6A23C;
}

.text-info {
    color: #909399;
}

.fr {
    float: right;
}
</style>
